// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4a6f6085","488":"b7f700ae","977":"78e5267d"}[chunkId] + ".chunk.js";
};